module.exports = __webpack_public_path__ + "static/media/12.af22164d.jpg";